if (!customElements.get('robo-product-list')) {
  customElements.define('robo-product-list', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.initialize());
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    initialize() {
      if (!this.isConnected || this.ready) return;
      this.container = this.closest('#ProductGridContainer');
      this.list = this.container?.querySelector(this.dataset.listSelector);
      this.button = this.querySelector('.robo-list-more');
      this.status = this.querySelector('.robo-list-status');
      if (!this.list || !this.button || !this.status) return;
      this.ready = true;
      this.batchSize = Number(this.dataset.pageSize) || 24;
      this.nextUrl = this.dataset.nextUrl;
      this.pending = [];
      this.seen = new Set(Array.from(this.list.children, item => this.itemKey(item)).filter(Boolean));
      this.querySelector('.robo-list-fallback')?.setAttribute('hidden', '');
      this.button.addEventListener('click', () => this.fill(this.list.children.length + this.batchSize));
      this.updateStatus();
      this.fill(this.batchSize);
    }
    itemKey(item) {
      return item.querySelector('.card__heading a')?.getAttribute('href') || item.querySelector('a[href]')?.getAttribute('href');
    }
    updateStatus(error = false) {
      const count = this.list.children.length;
      const text = count ? this.dataset.countLabel.replace('[count]', count) : this.dataset.emptyLabel;
      this.status.textContent = error ? text + ' ' + this.dataset.errorLabel : text;
      this.button.hidden = !this.nextUrl && !this.pending.length;
    }
    async fill(targetCount) {
      if (this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.querySelector('.robo-list-label').hidden = true;
      this.querySelector('.robo-list-loading').hidden = false;
      this.container.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      let failed = false;
      try {
        while (this.list.children.length < targetCount && this.isConnected) {
          while (this.pending.length && this.list.children.length < targetCount) {
            const item = this.pending.shift();
            item.classList.add('scroll-trigger--cancel');
            item.classList.remove('scroll-trigger--offscreen');
            this.list.append(item);
          }
          if (this.list.children.length >= targetCount || !this.nextUrl) break;
          const url = new URL(this.nextUrl, window.location.href);
          if (url.origin !== window.location.origin) throw new Error('Invalid product list URL');
          url.searchParams.set('section_id', this.dataset.sectionId);
          for (const key of ['preview_theme_id', 'oseid']) {
            const value = new URLSearchParams(window.location.search).get(key);
            if (value) url.searchParams.set(key, value);
          }
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Product list request failed');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fetchedList = parsed.querySelector(this.dataset.listSelector);
          if (!fetchedList && !parsed.querySelector('#product-grid')) throw new Error('Missing product list');
          const fetchedControl = parsed.querySelector('robo-product-list');
          this.nextUrl = fetchedControl?.dataset.nextUrl || '';
          for (const item of Array.from(fetchedList?.children || [])) {
            if (!item.matches('li.grid__item')) continue;
            const key = this.itemKey(item);
            if (key && this.seen.has(key)) continue;
            if (key) this.seen.add(key);
            this.pending.push(item);
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') failed = true;
      } finally {
        this.busy = false;
        if (this.isConnected) {
          this.container.removeAttribute('aria-busy');
          this.button.disabled = false;
          this.querySelector('.robo-list-label').hidden = false;
          this.querySelector('.robo-list-loading').hidden = true;
          this.updateStatus(failed);
        }
      }
    }
  });
}
